import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { filter, interval, map, take } from 'rxjs';
import { ISnackbarData } from './snackbar.service';

@Component({
  selector: 'ss-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule,
    MatButtonModule,
    MatCardModule
  ],
  host: {
    class: 'padding-standard'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SnackbarComponent {

  readonly LINK_OUTLET_IDENTIFIER = '@linkOutlet';

  readonly typeToIcon: { [type in ISnackbarData['type']]: string } = {
    error: 'error',
    info: 'info',
    success: 'check',
    warn: 'warning'
  }
  get icon() {
    return this.typeToIcon[this.data.type]
  }

  readonly typeToTextClass: { [type in ISnackbarData['type']]: string } = {
    error: 'warn-text',
    info: 'primary-text',
    success: 'accent-text',
    warn: 'warn-text',
  }
  get textClass() {
    return this.typeToTextClass[this.data.type]
  }


  readonly typeToColor: { [type in ISnackbarData['type']]: 'primary' | 'accent' | 'warn' } = {
    error: 'warn',
    info: 'primary',
    success: 'accent',
    warn: 'warn'
  }
  get color() {
    return this.typeToColor[this.data.type]
  }

  get hasLinkOutlet() {
    return this.data.message.includes(this.LINK_OUTLET_IDENTIFIER);
  }

  get messageParts() {

    return this.data.message.split(this.LINK_OUTLET_IDENTIFIER).reduce<{ type: 'a' | 'span', text: string }[]>((messageParts, part, idx, arr) => {
      messageParts.push({ type: 'span', text: part });
      if (arr.length - 1 !== idx) {
        messageParts.push({ type: 'a', text: '' });
      }

      return messageParts;
    },
      []
    )
  }

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) readonly data: ISnackbarData,
    private readonly _elementRef: ElementRef<HTMLElement>,
    private readonly _snackbarRef: MatSnackBarRef<SnackbarComponent>
  ) {

  }




  ngAfterViewInit() {
    // this._elementRef.nativeElement.style.backgroundColor = this.background;

    if (this.data.offsetTop) {
      interval(
        200
      )
        .pipe(
          take(10),
          map(() => document.querySelector('.cdk-global-overlay-wrapper') as HTMLElement),
          filter(Boolean),
          take(1)
        )
        .subscribe((pane) => {
          pane.style.paddingTop = '40px';
        })


    }
  }

  dismiss() {
    this._snackbarRef.dismiss();
  }

  dismissWithAction() {
    this._snackbarRef.dismissWithAction();
  }
}
